import { render } from "./OapVideo.vue?vue&type=template&id=7f4ab6cc"
import script from "./OapVideo.vue?vue&type=script&lang=js"
export * from "./OapVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__